/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Row, Col, Form, Button, FormCheck, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { EmailInput, PasswordInput } from './components';
import './styles.css';

export interface IFormCompProps {
  fields?: any;
  initialData?: any;
  authType?: 'IDENTIFIER' | 'PASSWORD' | 'OTP';
  submitButtonLabel?: string;
  onFormSubmit?(payload: any): void;
  renderSubmitButton?(): void;
  labelColor?: string;
  rememberMeText?: string;
  lostPasswordText?: string;
  lostPasswordLink?: string;
}

export const FormComp = (props: IFormCompProps) => {
  const {
    authType,
    fields,
    initialData,
    rememberMeText,
    lostPasswordText,
    lostPasswordLink,
    submitButtonLabel,
    onFormSubmit,
    renderSubmitButton,
  } = props;
  const [formData, updateFormData] = useState<any>(initialData ?? {});
  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState<any>({});

  const _renderSubmitButton = () => {
    if (renderSubmitButton) {
      return renderSubmitButton();
    }
    return (
      <div className="mt-3">
        <Button
          variant="secondary"
          type="submit"
          className="mt-2 animate-up-2"
          style={{
            width: '50%',
            borderRadius: '0px',
            height: '40px',
            fontWeight: 'bold',
          }}
        >
          {submitButtonLabel}
        </Button>
      </div>
    );
  };

  const handleSubmit = (e?: any) => {
    const form = e.currentTarget;
    const isValid = form.checkValidity();
    e.preventDefault();
    e.stopPropagation();
    let hasError = false;
    const errorsObj: any = {};
    // let _fields = [];
    // _fields = fields;

    setValidated(true);
    if (!hasError && isValid) {
      setErrors({});
      onFormSubmit && onFormSubmit(formData);
    } else {
      window?.scrollTo(0, 0);
      setErrors(errorsObj);
    }
  };
  const handleCompChange = (id: string, payload: any) => {
    if (id && payload && errors[id]) {
      delete errors[id];
    }
    updateFormData({
      ...formData,
      [id]: payload,
    });
  };

  const _handleRememberMeChange = (payload: any) => {
    if (payload && errors['rememberMe']) {
      delete errors['rememberMe'];
    }
    updateFormData({
      ...formData,
      ['rememberMe']: payload?.target?.checked,
    });
  };

  const _renderAuth = () => {
    if (authType === 'PASSWORD') {
      return (
        <Col key={`layout-1-columns-password`} sm={12} className="mb-3">
          <Form.Group>
            <PasswordInput
              {...fields?.password}
              value={initialData?.password}
              onCompChange={handleCompChange}
            />
            <div className="d-flex justify-content-between align-items-top mb-4 mt-2">
              <Form.Check type="checkbox">
                <FormCheck.Input
                  id="rememberMe"
                  className="me-2"
                  onChange={_handleRememberMeChange}
                />
                <FormCheck.Label htmlFor="rememberMe" className="mb-0">
                  {rememberMeText}
                </FormCheck.Label>
              </Form.Check>
              <Card.Link
                className="small text-end"
                as={Link}
                to={lostPasswordLink}
              >
                {lostPasswordText}
              </Card.Link>
            </div>
          </Form.Group>
        </Col>
      );
    }
  };
  const _renderLayout = () => {
    return (
      <Row key={`layout-1-row-default-layout`}>
        <Col key={`layout-1-columns-email`} className="mb-3">
          <EmailInput
            {...fields?.email}
            value={initialData?.email}
            labelColor={'#000'}
            onCompChange={handleCompChange}
          />
        </Col>
        {_renderAuth()}
      </Row>
    );
  };
  return (
    <>
      <Form
        noValidate
        validated={validated}
        className="mt-4"
        onSubmit={handleSubmit}
      >
        <>
          {_renderLayout()}
          {/*{_renderFormGroup()}*/}
          {_renderSubmitButton()}
        </>
      </Form>
    </>
  );
};

FormComp.defaultProps = {
  authType: 'IDENTIFIER',
  rememberMeText: 'Remember me',
  lostPasswordText: 'Lost password?',
  lostPasswordLink: '/forgot-password',
  fields: {
    email: {
      id: 'email',
      label: 'Email',
      required: true,
      placeholder: 'Enter your email address',
      errorText: 'Email is required',
      readOnly: false,
    },
    password: {
      id: 'password',
      label: 'Password',
      required: true,
      errorText: 'Password is required',
      placeholder: 'Enter your password',
    },
    otp: {
      id: 'otp',
      label: 'Enter your OTP',
      required: true,
      errorText: 'OTP is required',
      placeholder: 'Enter your OTP',
    },
  },
};
